import React from "react";

import style from "./styles.module.scss";

export type IconTileTone = "primary" | "secondary" | "tertiary";
export type IconTileSize = "small" | "medium";

interface IconTileProps {
  filled?: boolean;
  icon: string;
  size?: IconTileSize;
  tone: IconTileTone;
}

const tones: { [key in IconTileTone]: string } = {
  primary: style.tonePrimary,
  secondary: style.toneSecondary,
  tertiary: style.toneTertiary,
};

const sizes: { [key in IconTileSize]: string } = {
  small: style.sizeSmall,
  medium: style.sizeMedium,
};

export default function IconTile({
  filled = false,
  icon,
  size = "medium",
  tone,
}: IconTileProps) {
  return (
    <div
      className={`${style.iconTile} ${tones[tone]} ${sizes[size]} ${
        filled ? style.filled : ""
      }`}
    >
      <span aria-hidden="true" className="material-symbols-sharp">
        {icon}
      </span>
    </div>
  );
}
